import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { LocalstorageService } from '../config/localstorage.service';
import { BOT_CONVERSATION_INFO } from '@algomusinc/domain';
import { EnvironmentService } from '../service/service.module';


@Injectable({
  providedIn: 'root'
})
export class BotService {
  environment = EnvironmentService.environment
  public notificationSubject = new BehaviorSubject<any>(null);
  public notificationSubject$ = this.notificationSubject.asObservable();
  constructor(public http: HttpClient, public storage: LocalstorageService) { }

  public GenerateToken = (userId?: any, name?: any) => {
    let obj= {"user": {"id": userId, "name": name}}
    return this.http.post<any>(`${this.environment.AppTokenGenerate}`, obj);
  }
  public RefreshBotToken = () => {
    return this.http.post<any>(`${this.environment.AppTokenRefresh}`, {});
  }
  public GetConversations = () => {
    return this.http.post<any>(`${this.environment.AppConversations}`, {});
  }
  public GetConversationActivity = (body: any) => {
    const conversationId = this.storage.get(BOT_CONVERSATION_INFO);
    return this.http.post<any>(`${this.environment.AppConversations}/${conversationId}/activities`, body);
  }
  public GetConversationActivityResponse = (id: any) => {
    const conversationId = this.storage.get(BOT_CONVERSATION_INFO);
    return this.http.get<any>(`${this.environment.AppConversations}/${conversationId}/activities?watermark=${id}`);
  }
  public GetPowerBiToken = (id: any) => {
    const conversationId = this.storage.get(BOT_CONVERSATION_INFO);
    return this.http.get<any>(`${this.environment.AppConversations}/${conversationId}/activities?watermark=${id}`);
  }
  public GetMicrosoftLoginToken = (params: any) => {
    return this.http.get(this.environment.AccessToken, { params });
  }
  public SendBroadCast = (model: any) => {
    return this.http.post<any>(`${this.environment.NotificationCommon}/SendBroadCast`, model);
  }
  public ShareMenu = (model: any) => {
    return this.http.post<any>(`${this.environment.NotificationCommon}/Share`, model);
  }
}
